import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../Onboarding.module.css';
import * as utils from '../../../utils/utils';
import HQDialog from '../../HQDialog/HQDialog';

export default class OnboardingResume extends React.Component {

    constructor(props) {
        super(props);

        console.log('connectionId', this.props.connectionId);

        this.state = {
            isDragActive: false,
            resumeFile: null,
            uploadProgress: 0,
            isUploading: false,
            isProcessingResume: false,
            showSkipResume: false,

            connectionId: this.props.connectionId || null,

            errorText: '',
        };
    };

    componentDidMount() {
        if (!utils.isLoggedIn()) {
            window.location.href = '/signin';
            return;
        }
    };

    componentWillUnmount() {
    };

    getErrorMessage = (error, fallbackText) => {
        if (error && typeof error === 'object' && typeof error.message === 'string' && error.message.trim() !== '') {
            return error.message;
        }

        if (typeof error === 'string' && error.trim() !== '') {
            return error;
        }

        return fallbackText;
    };

    getValidatedPdfFile = (file) => {
        if (!file) {
            return null;
        }

        const isPdfMime = file.type === 'application/pdf';
        const isPdfName = file.name.toLowerCase().endsWith('.pdf');

        if (!isPdfMime && !isPdfName) {
            return null;
        }

        return file;
    };

    onFileChange = (event) => {
        const file = event.target.files && event.target.files[0];

        if (!file) {
            this.setState({
                resumeFile: null,
                errorText: '',
            });
            return;
        }

        const validatedFile = this.getValidatedPdfFile(file);

        if (!validatedFile) {
            this.setState({
                resumeFile: null,
                errorText: 'Please select a PDF file.',
            });
            return;
        }

        this.setState({
            resumeFile: validatedFile,
            errorText: '',
        });
    };

    onDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.state.isDragActive) {
            this.setState({ isDragActive: true });
        }
    };

    onDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ isDragActive: false });
    };

    onDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const file = event.dataTransfer?.files && event.dataTransfer.files[0];
        const validatedFile = this.getValidatedPdfFile(file);

        if (!validatedFile) {
            this.setState({
                isDragActive: false,
                resumeFile: null,
                errorText: 'Please drop a PDF file.',
            });
            return;
        }

        this.setState({
            isDragActive: false,
            resumeFile: validatedFile,
            errorText: '',
        });
    };

    uploadAndProcessResume = async () => {
        const {
            resumeFile,
            connectionId,
        } = this.state;

        if (!resumeFile) {
            this.setState({ errorText: 'Please choose a PDF resume first.' });
            return;
        }

        // if (!connectionId) {
        //     alert('WebSocket is not connected yet. Please wait...');
        //     return;
        // }

        this.setState({
            isUploading: true,
            isProcessingResume: false,
            uploadProgress: 0,
            errorText: '',
        });

        try {
            const uploadData = await utils.sendRequest('/resume/getResumeUploadData', {});
            const {
                uuidKey,
                originalMediaSignedUrl,
            } = uploadData || {};

            if (!uuidKey || !originalMediaSignedUrl) {
                throw new Error('Could not prepare resume upload data.');
            }

            await utils.uploadFileToSignedUrl(originalMediaSignedUrl, resumeFile, {
                contentType: 'application/pdf',
                onProgress: (progress) => {
                    this.setState({ uploadProgress: progress });
                }
            });

            this.setState({
                isUploading: false,
                isProcessingResume: true,
            });

            await utils.sendRequest('/resume/processResume', {
                uuidKey,
                connectionID: connectionId,
            });

            this.setState({
                isUploading: false,
                isProcessingResume: false,
                uploadProgress: 0,
                errorText: '',
            }, this.props.onContinue);
        }
        catch (error) {
            console.log('resume onboarding error', error);
            this.setState({
                isUploading: false,
                isProcessingResume: false,
                errorText: this.getErrorMessage(error, 'Could not upload and process resume. Please try again.'),
            });
        }
    };

    showSkipResume = () => {
        this.setState({
            showSkipResume: true,
        });
    };

    renderSkipResumeDialog = () => {
        const dialogNode = (
            this.state.showSkipResume &&
            <HQDialog
                title="Skip Resume"
                message="Are you sure you want to skip uploading resume? Uploading sets up your profile and helps us match you with relevant opportunities and people. You can always upload your resume later."
                primaryButtonText="Skip"
                onPrimaryClick={this.skipResume}
                onCancelClick={() => this.setState({ showSkipResume: false })}
            />
        );

        const portalNode = typeof this.props.getDialogPortalNode === 'function'
            ? this.props.getDialogPortalNode()
            : this.props.dialogPortalNode;

        if (portalNode) {
            return ReactDOM.createPortal(dialogNode, portalNode);
        }

        return dialogNode;
    };

    skipResume = () => {
        this.setState({
            showSkipResume: false,
            errorText: '',
        }, this.props.onSkip);
    };

    render() {
        const {
            isDragActive,
            resumeFile,
            uploadProgress,
            isUploading,
            isProcessingResume,
            errorText,
        } = this.state;

        return (
            <>

                <h2 className={styles.formTitle}>Let HQ know who you are</h2>
                <p className={styles.formText}>Upload your latest resume (pdf) and let HQ handle the rest</p>

                <div className={styles.form}>
                    <div className={styles.fieldGroup}>
                        <label className={styles.label} htmlFor='onboarding-resume-file'>Resume PDF</label>
                        <div
                            className={`${styles.dropZone} ${isDragActive ? styles.dropZoneActive : ''} ${(isUploading || isProcessingResume) ? styles.dropZoneDisabled : ''}`}
                            onDragOver={this.onDragOver}
                            onDragLeave={this.onDragLeave}
                            onDrop={this.onDrop}
                        >
                            <input
                                id='onboarding-resume-file'
                                type='file'
                                accept='application/pdf,.pdf'
                                className={styles.hiddenFileInput}
                                onChange={this.onFileChange}
                                disabled={isUploading || isProcessingResume}
                            />
                            <label className={styles.dropZoneInner} htmlFor='onboarding-resume-file'>
                                <span className={styles.dropZoneTitle}>Drag and drop your resume here</span>
                                <span className={styles.dropZoneText}>or click to choose a PDF file</span>
                            </label>
                        </div>

                        {
                            resumeFile &&
                            <p className={styles.fileName}>{resumeFile.name}</p>
                        }
                    </div>

                    <div className={styles.progressWrap}>
                        <div className={styles.progressTrack}>
                            <div className={styles.progressFill} style={{ width: `${uploadProgress}%` }} />
                        </div>
                        <div className={styles.progressText}>
                            {isProcessingResume ? 'Processing resume...' : `Upload progress: ${uploadProgress}%`}
                        </div>
                    </div>

                    <button
                        className={styles.primaryButton}
                        type='button'
                        onClick={this.uploadAndProcessResume}
                        disabled={isUploading || isProcessingResume}
                    >
                        {isProcessingResume ? 'Processing...' : (isUploading ? 'Uploading...' : 'Upload & Continue')}
                    </button>

                    <button
                        className={styles.secondaryButton}
                        type='button'
                        onClick={this.showSkipResume}
                        disabled={isProcessingResume || isUploading}
                    >
                        Skip
                    </button>
                </div>

                {
                    errorText !== '' &&
                    <div className={styles.errorBox}>{errorText}</div>
                }

                {this.renderSkipResumeDialog()}
            </>
        );
    };

}
